import axios from 'axios';
import qs from 'qs';
import { get } from 'lodash';

const CASHREGISTER_RIGHTS_LIST_LOAD = 'CASHREGISTER_RIGHTS_LIST_LOAD';
const CASHREGISTER_RIGHTS_LIST_SUCCESS = 'CASHREGISTER_RIGHTS_LIST_SUCCESS';
const CASHREGISTER_RIGHTS_LIST_FAILED = 'CASHREGISTER_RIGHTS_LIST_FAILED';
const CASHREGISTER_RIGHTS_SET_LOADING = 'CASHREGISTER_RIGHTS_SET_LOADING';

const CASHREGISTER_RIGHTS_FORM_LOAD = 'CASHREGISTER_RIGHTS_FORM_LOAD';
const CASHREGISTER_RIGHTS_FORM_SUCCESS = 'CASHREGISTER_RIGHTS_FORM_SUCCESS';
const CASHREGISTER_RIGHTS_FORM_FAILED = 'CASHREGISTER_RIGHTS_FORM_FAILED';

const CASHREGISTER_RIGHT_DELETE_LOAD = 'CASHREGISTER_RIGHT_DELETE_LOAD';
const CASHREGISTER_RIGHT_DELETE_SUCCESS = 'CASHREGISTER_RIGHT_DELETE_SUCCESS';
const CASHREGISTER_RIGHT_DELETE_FAILED = 'CASHREGISTER_RIGHT_DELETE_FAILED';

const CASHREGISTER_RIGHT_EDIT_LOAD = 'CASHREGISTER_RIGHT_EDIT_LOAD';
const CASHREGISTER_RIGHT_EDIT_SUCCESS = 'CASHREGISTER_RIGHT_EDIT_SUCCESS';
const CASHREGISTER_RIGHT_EDIT_FAILED = 'CASHREGISTER_RIGHT_EDIT_FAILED';

const CASHREGISTER_RIGHT_VIEW_LOAD = 'CASHREGISTER_RIGHT_VIEW_LOAD';
const CASHREGISTER_RIGHT_VIEW_SUCCESS = 'CASHREGISTER_RIGHT_VIEW_SUCCESS';
const CASHREGISTER_RIGHT_VIEW_FAILED = 'CASHREGISTER_RIGHT_VIEW_FAILED';

const CASHREGISTER_RIGHTS_RESET = 'CASHREGISTER_RIGHTS_RESET';
const CASHREGISTER_RIGHTS_RESET_FORM = 'CASHREGISTER_RIGHTS_RESET_FORM';

const initialState = {
  loading: false,
  success: false,
  saved: false,
  failed: false,
  data: [],
  message: null,
  total: 0,
  limit:process.env.REACT_APP_LIST_LIMIT,
  page: null,
  order: '',
  orderMode: 'ASC',
  deleted: false,
  deletedId: null,
  formErrors: {},
  viewData: null,
  viewLoading: false,
  commentThread: false,
  id: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CASHREGISTER_RIGHTS_RESET:
      return {
        ...initialState
      };
    case CASHREGISTER_RIGHTS_RESET_FORM:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        formErrors: {},
        viewData: null,
        viewLoading: false,
        commentThread: false,
        id: null
      };
    case CASHREGISTER_RIGHT_DELETE_LOAD:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        viewLoading: false
      };
    case CASHREGISTER_RIGHTS_LIST_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        viewLoading: false
      };
    case CASHREGISTER_RIGHT_EDIT_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: false
      };
    case CASHREGISTER_RIGHT_VIEW_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: true
      };
    case CASHREGISTER_RIGHTS_FORM_LOAD:
      return {
        ...state,
        loading: false,
        failed: false,
        message: null,
        viewLoading: false
      };
    case CASHREGISTER_RIGHTS_FORM_FAILED:
    case CASHREGISTER_RIGHT_EDIT_FAILED:
    case CASHREGISTER_RIGHT_DELETE_FAILED:
    case CASHREGISTER_RIGHTS_LIST_FAILED:
    case CASHREGISTER_RIGHT_VIEW_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        saved: false,
        failed: true,
        message: action.message,
        formErrors: action.formErrors || {},
        deleted: true,
        deletedId: null,
        viewLoading: false
      };
    case CASHREGISTER_RIGHTS_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        failed: false,
        data: action.data,
        total: action.total,
        limit: action.limit,
        page: action.page,
        order: action.order,
        orderMode: action.orderMode
      };
      case CASHREGISTER_RIGHT_VIEW_SUCCESS:
        return {
            ...state,
            loading: false,
            success: true,
            failed: false,
            viewData: action.viewData,
            commentThread: action.commentThread || false,
            viewLoading: false
        };
    case CASHREGISTER_RIGHTS_FORM_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        loading: false,
        success: true,
        failed: false,
        viewLoading: false
      };
    case CASHREGISTER_RIGHT_DELETE_SUCCESS:
      return {
        ...state,
        deleted: true,
        deletedId: action.id
      };
    case CASHREGISTER_RIGHT_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        failed: false,
        message: null,
        formErrors: {},
        id: action.id,
        viewLoading: false
      };
    case CASHREGISTER_RIGHTS_SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        viewLoading: false
      };
    default:
      return state;
  }
}

export const reset = () => dispatch => {
  dispatch({
    type: CASHREGISTER_RIGHTS_RESET
  });
};

export const resetForm = () => dispatch => {
  dispatch({
    type: CASHREGISTER_RIGHTS_RESET_FORM
  });
};

export const updateRight = (cashID, model,id,data) => dispatch => {
  dispatch({
    type: CASHREGISTER_RIGHT_EDIT_LOAD
  });

    let obj = {};
    obj[model] = data;

  return axios.put(`/v1/cashregister/${cashID}/cashregister-rights/${id}`, obj).then(
      () => dispatch({
        type: CASHREGISTER_RIGHT_EDIT_SUCCESS
      })
  ).catch(error => {
    dispatch({
      type: CASHREGISTER_RIGHT_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const viewRight = (cashID, id) => dispatch => {
    dispatch({
        type: CASHREGISTER_RIGHT_VIEW_LOAD
    });
    return axios.get(`/v1/cashregister/${cashID}/cashregister-rights/raw/${id}`).then(
        response => dispatch({
            type: CASHREGISTER_RIGHT_VIEW_SUCCESS,
            viewData: get(response, 'data.data'),
            commentThread: get(response, 'data.commentThread', false)
        })
    ).catch(error => {
        dispatch({
            type: CASHREGISTER_RIGHT_VIEW_FAILED,
            message: get(error, 'response.data.message', null)
        })
    });
};

export const createRight = (cashID, model, data) => dispatch => {
  dispatch({
    type: CASHREGISTER_RIGHT_EDIT_LOAD
  });

  let obj = {};
  obj[model] = data;

  return axios.post(`/v1/cashregister/${cashID}/cashregister-rights`, obj).then(response => dispatch({
    type: CASHREGISTER_RIGHT_EDIT_SUCCESS,
    id: get(response, 'data.data.id', null),
  })).catch(error => {
    dispatch({
      type: CASHREGISTER_RIGHT_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const rightsDelete = (cashID, id) => dispatch => {
  dispatch({
    type: CASHREGISTER_RIGHT_DELETE_LOAD
  });
  return axios.delete(`/v1/cashregister/${cashID}/cashregister-rights/${id}`)
      .then((response) => dispatch({
        type: CASHREGISTER_RIGHT_DELETE_SUCCESS,
        id
      })).catch(error => dispatch({
        type: CASHREGISTER_RIGHT_DELETE_FAILED,
        message: get(error, 'response.data.message', null)
      }));
};

export const setLoading = (loading) => dispatch => {
  dispatch({
    type: CASHREGISTER_RIGHTS_SET_LOADING,
    loading
  });
};

export const rightsList = (cashID, page, keyword, sort, filters, perPage) => dispatch => {
  dispatch({
    type: CASHREGISTER_RIGHTS_LIST_LOAD
  });

  let params = {
    page,
    keyword,
    sort,
    'per-page': perPage
  };

  params[filters.model] = filters.filters;

  return axios.get(
      `/v1/cashregister/${cashID}/cashregister-rights`,
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
  ).then(response => {
    let sort = get(response, 'data.sort', null),
        mode = 'ASC';
    if(sort && sort.indexOf('-') !== -1) {
      mode = 'DESC';
      sort = sort.substr(1);
    }
    return dispatch({
      type: CASHREGISTER_RIGHTS_LIST_SUCCESS,
      data: get(response, 'data.data', null),
      page: get(response, 'data.page', 0),
      limit: get(response, 'data.per-page', 0),
      total: get(response, 'data.total', 0),
      order: sort,
      orderMode: mode
    });
  })
  .catch(error => dispatch({
    type: CASHREGISTER_RIGHTS_LIST_FAILED,
    message: get(error, 'response.data.message', null)
  }));
};
